import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  DropDownData: [], 
};

const dropDownDataSlice = createSlice({
  name: "DropDownData",
  initialState,
  reducers: {
    updateDropDown: (state, action) => {
      const index = state.DropDownData.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.DropDownData[index] = action.payload;
      } else {
        state.DropDownData.push(action.payload);
      }
    },
  },
});

// Export the action to use in components
export const { updateDropDown } = dropDownDataSlice.actions;

// Export the reducer to use in the store
export default dropDownDataSlice.reducer;
